import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonCard, IonCardContent } from '@ionic/angular/standalone';
import { DateFnsModule } from 'ngx-date-fns';
import { DecaStoreService } from '../deca-store.service';

@Component({
  selector: 'lib-deca-counters-credits',
  templateUrl: './deca-counters-credits.component.html',
  styleUrls: ['./deca-counters-credits.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonCardContent, IonCard, DateFnsModule],
})
export class DecaCountersCreditsComponent {
  private readonly decaStoreService = inject(DecaStoreService);

  protected readonly availableCredits = this.decaStoreService.availableCredits;
  protected readonly promotionalCredits = this.decaStoreService.promotionalCredits;
  protected readonly promotionalCreditsExpireAt = this.decaStoreService.promotionalCreditsExpireAt;
}
